import React from "react";
import { UserAuth } from "../context/AuthContext";
import { useTranslation } from "../hooks/useTranslation";

const Forbidden = () => {
  const { user } = UserAuth();
  const { t } = useTranslation();

  return (
    <>
      <div className="w-full h-full pt-24 align-middle">
        <h1 className="text-center font-bold py-24 text-white">
          {t("forbiddenTitle")}
        </h1>

        {user?.uid && (
          <h2 className="text-center font-bold py-24 text-white">
            {t("yourUidIs")} {user.uid}
          </h2>
        )}
      </div>
    </>
  );
};

export default Forbidden;
